import { Icon } from './Icons';

export function UploadingRow({ entry }) {
  const pct = Math.round((entry.progress || 0) * 100);
  const sizeMb = entry.sizeBytes ? (entry.sizeBytes / 1024 / 1024).toFixed(1) : null;
  const status =
    entry.stage === 'analyzing'
      ? 'Analyzing artwork…'
      : `Uploading… ${pct}%`;
  return (
    <div className="file-row file-row--uploading">
      <div className="thumb upload-thumb">
        <Icon.Upload width="22" height="22" />
      </div>
      <div className="fr-meta">
        <div className="fr-line">
          <span className="fr-name">{entry.name}</span>
          {sizeMb && <span className="fr-sub small mono">{sizeMb} MB</span>}
        </div>
        <div className="upload-progress" aria-label={status}>
          <div
            className={`upload-progress__bar ${entry.stage === 'analyzing' ? 'is-analyzing' : ''}`}
            style={{ width: `${Math.max(pct, 2)}%` }}
          />
        </div>
        <div className="fr-sub small">{status}</div>
      </div>
      <div className="fr-price"></div>
      <div></div>
    </div>
  );
}
